const Footer = ({ company, onNavigate }) => {
  return (
    <footer className="bg-stone-950 text-stone-400 py-16 border-t border-stone-900">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Mobile View - Vertical Stack */}
        <div className="md:hidden flex flex-col justify-center items-center gap-6 text-center">
          <img
            src={company.logo}
            alt={`${company.name} logo`}
            className="h-10 w-10 rounded-full object-cover border border-amber-300/40"
          />
          <p className="text-sm font-medium tracking-widest text-white">{company.name}</p>

          <div className="flex flex-col gap-2">
            <p className="text-xs uppercase tracking-widest text-stone-500">Quick Links</p>
            <div className="flex flex-col gap-2">
              {['Home', 'About', 'Services', 'Projects', 'Team', 'Contact'].map((item) => (
                <button
                  key={item}
                  onClick={() => onNavigate(item)}
                  className="hover:text-amber-500 transition-colors text-xs uppercase tracking-widest"
                >
                  {item}
                </button>
              ))}
            </div>
          </div>

          <div className="w-12 border-t border-stone-700" />

          <div className="flex flex-col gap-2">
            <p className="text-xs uppercase tracking-widest text-stone-500">Legal</p>
            <div className="flex flex-col gap-2">
              <span className="text-xs uppercase tracking-widest text-stone-400">
                Privacy Policy
              </span>
              <span className="text-xs uppercase tracking-widest text-stone-400">
                Terms of Service
              </span>
            </div>
          </div>

          <a
            href={`mailto:${company.email}`}
            className="hover:text-amber-500 transition-colors text-xs"
            aria-label={`Email ${company.name} at ${company.email}`}
          >
            {company.email}
          </a>
        </div>

        {/* Desktop View - 3 Equal Columns */}
        <div className="hidden md:grid md:grid-cols-3 md:gap-16">
          {/* Left Column - Logo & Info */}
          <div className="flex flex-col gap-4">
            <img
              src={company.logo}
              alt={`${company.name} logo`}
              className="h-16 w-16 rounded-full object-cover border border-amber-300/40"
            />
            <div>
              <p className="text-lg font-medium tracking-widest text-white">{company.name}</p>
              <p className="text-xs uppercase tracking-widest text-amber-600 mt-1">Home & Decor</p>
            </div>
            <p className="text-sm text-stone-400 leading-relaxed">
              Transforming spaces into premium luxury habitats. Experts in Real Estate,
              Construction, PVC Decor, and Vastu.
            </p>
            <a
              href={`mailto:${company.email}`}
              className="hover:text-amber-500 transition-colors text-sm text-amber-600"
              aria-label={`Email ${company.name} at ${company.email}`}
            >
              {company.email}
            </a>
          </div>

          {/* Middle Column - Quick Links */}
          <div className="flex flex-col gap-4">
            <p className="text-xs uppercase tracking-widest text-stone-500 font-semibold">
              Quick Links
            </p>
            <div className="flex flex-col gap-3">
              {['Home', 'About', 'Services', 'Projects', 'Team', 'Contact'].map((item) => (
                <button
                  key={item}
                  onClick={() => onNavigate(item)}
                  className="hover:text-amber-500 transition-colors text-sm text-stone-400 text-left"
                >
                  {item}
                </button>
              ))}
            </div>
          </div>

          {/* Right Column - Legal */}
          <div className="flex flex-col gap-4">
            <p className="text-xs uppercase tracking-widest text-stone-500 font-semibold">Legal</p>
            <div className="flex flex-col gap-3">
              <span className="text-sm text-stone-400 hover:text-amber-500 transition-colors cursor-pointer">
                Privacy Policy
              </span>
              <span className="text-sm text-stone-400 hover:text-amber-500 transition-colors cursor-pointer">
                Terms of Service
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom - Copyright */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 mt-16 pt-8 border-t border-stone-800 text-center text-sm font-light">
        <p>{company.name} Home & Decor. All Rights Reserved.</p>
        <p className="mt-2">
          Powered By{' '}
          <a
            href="https://www.trivanahospitality.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-amber-500 hover:underline"
          >
            Trivana Hospitality
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
